/**
 * useCapabilities — reads the authoritative capability map the server sent at login
 * (GET /api/auth/me, stored in localStorage.userData). Never derive permissions from
 * role strings in the client — use this hook.
 *
 *   const { canManageServices } = useCapabilities();
 */
export function useCapabilities() {
    try {
        const userData = JSON.parse(localStorage.getItem('mh_userData') || '{}');
        return userData.capabilities || {};
    } catch (_) {
        return {};
    }
}
